module.exports = __webpack_public_path__ + "img/column-flame.1b01c2be.gif";